import React, { useState, useEffect } from 'react';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, LANGUAGE_NAMES_IN_THEIR_LANGUAGE } from '../../../service/constants';
import { getLanguageBadge } from '../../../utils/language.utils';

const LanguageFilter = ({ selectedLanguages, onLanguageChange }) => {
    const [localSelected, setLocalSelected] = useState(selectedLanguages);
    const allLanguages = SUPPORTED_LANGUAGES;
    const isAllSelected = localSelected.length === 0;
    
    useEffect(() => {
        setLocalSelected(selectedLanguages);
    }, [selectedLanguages]);
    
    const handleAllChange = (event) => {
        if (event.target.checked) {
            setLocalSelected([]);
            onLanguageChange([]);
        }
    };
    
    const handleLanguageChange = (lang) => {
        const wasSelected = localSelected.includes(lang);
        let newSelected;
        
        if (wasSelected) {
            newSelected = localSelected.filter(l => l !== lang);
        } else {
            newSelected = [...localSelected, lang];
        }
        
        const allSelected = allLanguages.every(l => newSelected.includes(l));
        if (allSelected) {
            newSelected = [];
        }
        
        setLocalSelected(newSelected);
        onLanguageChange(newSelected);
    };
    
    const getLanguageLabel = (lang) => {
        const name = LANGUAGE_NAMES_IN_THEIR_LANGUAGE[lang] || lang;
        return name;
    };
    
    return (
        <>
            <p>Idioma</p>
            <ul className="list-unstyled pl-3 language-filter">
                <li>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="lang-all"
                            checked={isAllSelected}
                            onChange={handleAllChange}
                        />
                        <label className="form-check-label" htmlFor="lang-all">
                            Todos
                        </label>
                    </div>
                </li>
                <li>
                    <div className="form-check form-check-badge d-flex align-items-center" style={{ gap: '0.25rem' }}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={`lang-${DEFAULT_LANGUAGE}`}
                            checked={localSelected.includes(DEFAULT_LANGUAGE)}
                            onChange={() => handleLanguageChange(DEFAULT_LANGUAGE)}
                        />
                        <div className="language-badges d-inline-block">
                            <span  className="language-badge badge badge-light mr-1">
                                {getLanguageBadge(DEFAULT_LANGUAGE)}
                            </span>
                        </div>
                        <label className="form-check-label" htmlFor={`lang-${DEFAULT_LANGUAGE}`}>
                            - Español
                        </label>
                    </div>
                </li>
                {SUPPORTED_LANGUAGES.filter(lang => lang !== DEFAULT_LANGUAGE).map(lang => {
                    const isSelected = localSelected.includes(lang);
                    return (
                        <li key={lang}>
                            <div className="form-check form-check-badge d-flex align-items-center" style={{ gap: '0.25rem' }}>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`lang-${lang}`}
                                    checked={isSelected}
                                    onChange={() => handleLanguageChange(lang)}
                                />
                                <div className="language-badges d-inline-block">
                                    <span  className="language-badge badge badge-light mr-1">
                                        {getLanguageBadge(lang)}
                                    </span>
                                </div>
                                <label className="form-check-label" htmlFor={`lang-${lang}`}>
                                    - {getLanguageLabel(lang)}
                                </label>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </>
    );
};

export default LanguageFilter;
